module.exports = __webpack_public_path__ + "img/new3-3.96e41bac.jpg";